import { useEffectOnce } from 'react-use';
import config from '@/config/general';
export const pageViewCounters = {
  chartBuilder: `${config.productNameSpace}-chart-builder-views`,
  calculator: `${config.productNameSpace}-calculator-views`,
  templateProfile: `${config.productNameSpace}-template-profile-views`
};
let lastPageViewUrl = ''; // Track and delete page view via local storage

export const useTrackPageViews = viewCounterName => {
  // Track page view for provided counter name
  useEffectOnce(() => {
    if (!viewCounterName) return;
    if (typeof location === 'undefined') return; // non-browser env

    if (lastPageViewUrl === location.href) return; // Prevent duplicate counts

    const views = Number(localStorage.getItem(viewCounterName) || 0);
    localStorage.setItem(viewCounterName, `${views + 1}`);
    lastPageViewUrl = location.href;
  });
};
export default useTrackPageViews; // Return all views collected
// from all the view counters

export const getAllViewCounters = () => {
  const viewCounters = {};
  const counters = Object.keys(pageViewCounters);

  for (const counter of counters) {
    const views = Number(localStorage.getItem(pageViewCounters[counter]) || 0);
    if (views > 0) viewCounters[counter] = views;
  }

  return viewCounters;
}; // Remove all view counters for all pages

export const deleteAllViewCounters = () => {
  Object.values(pageViewCounters).forEach(counter => {
    localStorage.removeItem(counter);
  });
};